(function () {
    'use strict';

    angular
        .module('elogbooks.common.jobs.workflow')
        .controller('JobReassignOperativeController', JobReassignOperativeController);

    JobReassignOperativeController.$inject = [
        'apiClient',
        '$state',
        'messenger',
        'jobResponse',
        'operativeCollectionResponse',
        'formData',
        'scopeData',
        'jobSettings',
        'elbSettings',
        '$scope'
    ];

    function JobReassignOperativeController (
        apiClient,
        $state,
        messenger,
        jobResponse,
        operativeCollectionResponse,
        formData,
        scopeData,
        jobSettings,
        elbSettings,
        $scope
    ) {
        var vm = this;
        vm.job = jobResponse;

        angular.extend(vm, scopeData);

        vm.submit = submitAction;
        vm.changeOperative = changeOperative;
        vm.noteRequired = false;
        vm.data = formData;
        vm.submitDisabled = true;
        vm.validateDate = false;
        vm.dateInvalid = false;
        vm.operativeSelectModel.onSelect = vm.operativeSelectModel.onRemove = vm.changeOperative;
        vm.allowAttendBy = vm.job.status !== 'commenced' && jobSettings.allowAttendByOnReassignOperative && elbSettings.getSetting('reassign_operatives_attend_by_enabled').value;
        vm.attendanceDueAtFieldDisabled = new Date(vm.job.completionDueAt).getTime() < Date.now();

        if (vm.allowAttendBy) {
            vm.data.attendanceDueAt = new Date(vm.job.attendanceDueAt);

            if (!vm.attendanceDueAtFieldDisabled) {
                vm.minDate = new Date();
                vm.validateDate = !vm.attendanceDueAtFieldDisabled;
            }
        }

        $scope.$watch(
            function () {
                return vm.data.attendanceDueAt;
            },
            function (newVal) {
                if (vm.validateDate) {
                    if (newVal) {
                        var selectedDate = new Date(newVal);
                        vm.dateInvalid = selectedDate < vm.minDate;
                    } else {
                        vm.dateInvalid = true;
                    }
                }
            }
        );

        function submitAction () {
            if (vm.validateDate && vm.dateInvalid) {
                return;
            }

            return apiClient.create(vm.job.getLink(vm.action), vm.data).then(function (response) {
                if (response) {
                    return $state.go('^.^', {}, { reload: $state.get('^.^.^') }).then(function () {
                        messenger.success(vm.translation + '_SUCCESS');
                    });
                }
            });
        }

        function changeOperative () {
            if (vm.operativeSelectModel.selected && typeof vm.operativeSelectModel.selected !== 'undefined') {
                vm.data._links.operative = vm.operativeSelectModel.selected;
                vm.submitDisabled = false;
            } else {
                vm.operativeSelectModel.selected = null;
                delete vm.data._links.operative;
                vm.submitDisabled = true;
            }
        }
    }
})();
